import { TenantGeneralData } from './tenantGeneralData';

export class Contact extends TenantGeneralData {
  referentName: string = null;
  phone: string = null;
  fax: string = null;
  mobilePhone: string = null;
  email: string = null;
  legalMail: string = null;
  note: string = null;

  constructor() {
    super();
  }
}
